import { Stack, styled } from '@mui/material';
import { GridRowCell } from '@schooly/style';

import { GridRowDate, GridRowItem, GridRowName } from '../Grid/Grid';

export const ListViewAssessmentEntriesRowItem = styled(GridRowItem)(({ theme }) => ({
  gap: theme.spacing(1.5),
}));

export const ListViewAssessmentEntriesExtraRow = styled(GridRowItem)(({ theme }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  paddingRight: 0,
}));

export const ListViewAssessmentEntriesNameCell = styled(GridRowName)(({ theme }) => ({
  minWidth: 150,
  overflow: 'hidden',
  display: 'flex',
  gap: theme.spacing(1),
  paddingRight: theme.spacing(2),
  alignItems: 'center',
}));

export const ListViewAssessmentEntriesTagsCell = styled(Stack)(({ theme }) => ({
  flex: '0 0 200px',
  flexDirection: 'row',

  width: theme.spacing(24),
  alignItems: 'center',
  gap: theme.spacing(),
  paddingRight: theme.spacing(2),

  '& > *': { flex: '0 1 auto' },

  '& .MuiTypography-root, .UIKit-TagGroup__text': {
    '.GridRow:hover &, .GridRowItem:hover &': {
      color: theme.palette.primary.main,
    },
  },

  '& .UIKit-TagGroup': {
    '.GridRow:hover &, .GridRowItem:hover &': {
      backgroundColor: theme.palette.background.paper,
    },
    '.svg-icon': {
      '.GridRow:hover &, .GridRowItem:hover &': {
        color: theme.palette.primary.main,
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    flex: '0 0 250px',
  },
}));

export const ListViewAssessmentEntriesDateCell = styled(GridRowDate)(({ theme }) => ({
  '.GridRow:hover &, .GridRowItem:hover &': {
    color: theme.palette.text.primary,
  },
}));

export const ListViewAssessmentEntriesHeaderCell = styled(GridRowCell)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& .MuiTypography-root, .UIKit-TagGroup__text': {
    '.GridRow:hover &, .GridRowItem:hover &': {
      color: theme.palette.primary.main,
    },
  },

  '& .UIKit-TagGroup': {
    '.GridRow:hover &, .GridRowItem:hover &': {
      backgroundColor: theme.palette.background.paper,
    },
    '.svg-icon': {
      '.GridRow:hover &, .GridRowItem:hover &': {
        color: theme.palette.primary.main,
      },
    },
  },
}));
